import deutsch from "./de";
import english from "./en";


const translation = {
    de : deutsch,
    en : english
}

export default translation;